import type { ReactNode } from "react";

export type FormSelectItem = { key: string; node: ReactNode };

export const campaignStatusSelectItems: FormSelectItem[] = [
	{
		key: "none",
		node: <span>Оберіть статус</span>,
	},
	{
		key: "enabled",
		node: <span>ENABLED</span>,
	},
	{
		key: "paused",
		node: <span>PAUSED</span>,
	},
];

export const appStoreSelectItems: FormSelectItem[] = [
	{
		key: "none",
		node: <span>Оберіть магазин</span>,
	},
	{
		key: "GOOGLE_APP_STORE",
		node: <span>GOOGLE_APP_STORE</span>,
	},
	{
		key: "APPLE_APP_STORE",
		node: <span>APPLE_APP_STORE</span>,
	},
];
